import { io } from 'socket.io-client';
import { CLAIM_JOIN, CLAIM_LEAVE } from './events';

const BASE_URL = (process.env.REACT_APP_SOCKET_SERVER_URL || 'ws://localhost:1235').replace(/\/+$/, '');

// Le backend émet les événements de réclamation (notif-message, notif-feedback,
// messages:seen) sur le namespace /claim ; la racine "/" n'a aucun gateway.
const URL = `${BASE_URL}/claim`;

const getToken = () => localStorage.getItem('accessToken') || '';

export const socket = io(URL, {
  transports: ['websocket', 'polling'],
  autoConnect: false,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  // Lu à chaque (re)connexion : un token rafraîchi est pris en compte.
  auth: (cb) => cb({ token: getToken() })
});

// Salles `claim:<id>` à rejoindre. Le serveur les oublie à chaque reconnexion,
// on les réémet donc sur chaque `connect`.
const joinedClaims = new Set();

socket.on('connect', () => {
  joinedClaims.forEach((claimId) => socket.emit(CLAIM_JOIN, claimId));
});

socket.on('disconnect', (reason) => {
  // Le serveur coupe la connexion quand le token est absent : ne pas boucler
  // tant que l'utilisateur n'est pas reconnecté.
  if (reason === 'io server disconnect' && getToken()) {
    socket.connect();
  }
});

socket.on('connect_error', (error) => {
  console.error('Socket connect error:', error?.message || error);
});

export const initializeSocket = () => {
  if (getToken() && !socket.connected) {
    socket.connect();
  }
};

export const disconnectSocket = () => {
  joinedClaims.clear();
  socket.disconnect();
};

export const joinClaimRoom = (claimId) => {
  if (!claimId) return;
  joinedClaims.add(String(claimId));
  if (socket.connected) socket.emit(CLAIM_JOIN, String(claimId));
};

export const leaveClaimRoom = (claimId) => {
  if (!claimId) return;
  joinedClaims.delete(String(claimId));
  if (socket.connected) socket.emit(CLAIM_LEAVE, String(claimId));
};

// Id de la réclamation concernée par un événement.
// Pour notif-message, le gateway calcule `claimId` à partir de `_id` en
// priorité : après un add-message, `_id` est celui du MESSAGE, et le vrai id
// de la réclamation est dans `message.claim`. On lit donc `message.claim`
// d'abord, puis `claimId` (Claim complet, shareMedia, notif-feedback,
// messages:seen).
export const getEventClaimId = (payload) => {
  const raw =
    payload?.message?.claim?._id ?? payload?.message?.claim ?? payload?.claimId;
  return raw ? String(raw) : null;
};
